<template>
  <div class="content">
    <div class="container">
      <div class="contacts">
        <div class="contacts-overlay-img d-none d-md-block">
          <img src="@/assets/img/bg/bg-07.png" alt="img" class="img-fluid" />
        </div>
        <div class="contacts-overlay-sm d-none d-md-block">
          <img src="@/assets/img/bg/bg-08.png" alt="img" class="img-fluid" />
        </div>
        <!-- Contact Details -->
        <div class="contact-details">
          <div class="row justify-content-center">
            <div class="col-md-4 col-lg-4 d-flex">
              <div class="card flex-fill">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span class="rounded-circle"
                      ><i class="ti ti-phone text-primary"></i
                    ></span>
                    <div>
                      <h6 class="fs-18 mb-1">Phone Number</h6>
                      <p class="fs-14">(888) 888-8888</p>
                      <p class="fs-14">(123) 456-7890</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-4 d-flex">
              <div class="card flex-fill">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span class="rounded-circle"
                      ><i class="ti ti-mail text-primary"></i
                    ></span>
                    <div>
                      <h6 class="fs-18 mb-1">Email Address</h6>
                      <p class="fs-14">truelysell@example.com</p>
                      <p class="fs-14">johnsmith@example.com</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-4 d-flex">
              <div class="card flex-fill">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <span class="rounded-circle"
                      ><i class="ti ti-map-pin text-primary"></i
                    ></span>
                    <div>
                      <h6 class="fs-18 mb-1">Address</h6>
                      <p class="fs-14">
                        367 Hillcrest Lane, Irvine, California, United States
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Contact Details -->

        <!-- Get In Touch -->
        <div class="row">
          <div class="col-md-6 d-flex align-items-center">
            <div class="contact-img flex-fill">
              <img
                src="@/assets/img/services/service-76.jpg"
                class="img-fluid"
                alt="img"
              />
            </div>
          </div>
          <div class="col-md-6 d-flex align-items-center justify-content-center">
            <div class="contact-queries flex-fill">
              <h2>Get In Touch</h2>
              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <div class="form-group">
                        <input class="form-control" type="text" placeholder="Your Name" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="mb-3">
                      <div class="form-group">
                        <input
                          class="form-control"
                          type="email"
                          placeholder="Your Email Address"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="mb-3">
                      <div class="form-group">
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Your Phone Number"
                        />
                      </div>
                    </div>
                    <div class="mb-3">
                      <vue-select
                        :options="ServContent"
                        id="servcontent"
                        placeholder="Select Services"
                      />
                    </div>
                    <div class="mb-3">
                      <div class="form-group">
                        <textarea
                          class="form-control"
                          placeholder="Type Message"
                          id="floatingTextarea"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 submit-btn">
                    <button class="btn btn-dark d-flex align-items-center" type="submit">
                      Send Message<i class="feather-arrow-right-circle ms-2"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- /Get In Touch -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ServContent: [
        "Select Services",
        "Car Repair",
        "Interior Designing",
        "House Cleaning",
      ],
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/contact-us");
    },
  },
};
</script>
